import { render } from "./TheTicketTitle.vue?vue&type=template&id=14c9ce54"
import script from "./TheTicketTitle.vue?vue&type=script&lang=js"
export * from "./TheTicketTitle.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "14c9ce54"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('14c9ce54', script)) {
    api.reload('14c9ce54', script)
  }
  
  module.hot.accept("./TheTicketTitle.vue?vue&type=template&id=14c9ce54", () => {
    api.rerender('14c9ce54', render)
  })

}

script.__file = "src/views/support/pageTitles/TheTicketTitle.vue"

export default script